'use strict';
export class JournalOptInController {
    constructor($scope, $location, TaskSelectionService, TaskDataService, $bridges, TaskCountdownService, UserInfoService, $translate, $timeout, $interval, $config) {
        const _journalTime = $config.getJournalTime();
        const _taskContext = TaskDataService.fetchContext();
        const _taskUUID = TaskSelectionService.getTaskUUID();
        const _task = _taskContext.read(_taskUUID);
        const _taskCountdown = TaskCountdownService.getInstance();
        const _userInfo = UserInfoService.getUserInfo();

        if(!_taskCountdown.isExpired() && _taskCountdown.getMode() === 'task'){
            $location.path('overview/' + _task.getUUID());
            return false;
        }

        if(!_task.hasJournal()){
            $location.path('/taskdone/'+$bridges.authentication().getUserUUID());
            return false;
        }

        if(_task.hasJournal() && _taskCountdown.getMode() === 'journal'){
            $location.path('/sheet/' + _task.getJournal().getUUID());
            return false;
        }

        if(_taskCountdown.isExpired() && _taskCountdown.getMode() === 'task'){
            _taskCountdown.setMode('journal');
            _taskCountdown.resetTime(_journalTime, 0, 'journal');
            console.log(_journalTime, 0, 'journal')
        }

        const startsJournalCountdown = () => {
            $timeout(() => {
                $scope.$apply(() => {
                    _taskCountdown.resetTime(_journalTime, 0, 'journal');
                    _taskCountdown.startMeasure();
                });
            }, 1);
        };

        $scope.candidate = _userInfo;

        $scope.onContinue = (val) => {
            if (_taskCountdown.getMode() === 'journal') {
                if (val) {
                    $timeout(() => {
                        $scope.$apply(() => {
                            _taskCountdown.startMeasure();
                            $location.path('/sheet/' + _task.getJournal().getUUID());
                        });
                    }, 1);
                } else {
                    $location.path('/taskdone/' + $bridges.authentication().getUserUUID());
                }
            }
        };

        $scope.onHomeButtonClick = () => {
            $location.path('overview/' + _task.getUUID());
        };
    }
}

export default function registerJournalOptInController(angular) {
    const module = angular.module('assessmentFrontendControllers');
    module.controller('JournalOptInController', ['$scope', '$location', 'TaskSelectionService', 'TaskDataService', '$bridges', 'TaskCountdownService', 'UserInfoService', '$translate', '$timeout', '$interval', '$config', JournalOptInController]);
}